import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useCan } from '@/features/auth/session.js';
import { Loading } from '@/components/shared/page-states.js';

/**
 * whatsapp.md section 5 / ui-contract.md section 1: "/" redirects to the
 * first page the signed-in user may see, in navigation order (الرسائل،
 * القوالب، الأنظمة المرتبطة، then الإعدادات -> المستخدمين، المجموعات - see
 * components/layout/nav-main.tsx). `_app.tsx`'s own layout has already
 * resolved the session by the time this renders, so `useCan` reads it from
 * the query cache with no extra loading state of its own.
 */
function AppIndexRedirect(): React.JSX.Element {
  const canListMessages = useCan('MESSAGE_LIST');
  const canListTemplates = useCan('TEMPLATE_LIST');
  const canListSystems = useCan('SYSTEM_LIST');
  const canListUsers = useCan('USER_LIST');
  const canListGroups = useCan('GROUP_LIST');

  if (canListMessages) return <Navigate to="/messages" />;
  if (canListTemplates) return <Navigate to="/templates" />;
  if (canListSystems) return <Navigate to="/systems" />;
  if (canListUsers) return <Navigate to="/settings/users" />;
  if (canListGroups) return <Navigate to="/settings/groups" />;

  // No visible page at all: the layout itself will not have rendered
  // navigation either; nothing to redirect to yet while the session is
  // still settling in the query cache.
  return <Loading />;
}

export const Route = createFileRoute('/_app/')({
  component: AppIndexRedirect,
});
